// extracted by mini-css-extract-plugin
module.exports = {"container":"_3c1dLd55v4VPd2VUBi-ZgN","cancelBtn":"_3LphAbzo9aQLBpEyMXZln-","icon":"_4wj03TYLXsSzNgCB4oOmv","saveBtn":"_3Nj5SZMSEWAQCkT_Gr3NsB"};